import {IFsSymbolData} from "../../../symbols/freespin/FreespinSymbol";
import {gsap} from "gsap";
import {FreespinTrainSymbol} from "../../../symbols/freespin/train/FreespinTrainSymbol";

export class FreespinTrainView extends PIXI.Container {

    protected _allSymbols:FreespinTrainSymbol[] = [];
    protected _reelId:number;
    protected _container:PIXI.Container;

    constructor(id:number) {
        super();
        this.name = "Reel " + id;
        this._reelId = id;
        this._container = new PIXI.Container();
        const isTopTrain:boolean = id === -1;
        this._container.position = new PIXI.Point(isTopTrain?1000:661, isTopTrain?100:1000);
        this.addChild(this._container);
        const trainsMask: PIXI.Graphics = new PIXI.Graphics();
        trainsMask.name = "trainsMask";
        trainsMask.beginFill(0xFFFF0B, 1);
        trainsMask.drawRect(0, 0, isTopTrain?600:140, isTopTrain?600:440);
        trainsMask.position.set(isTopTrain?10:600, isTopTrain?10:130);

        // todo enable reel area masking
        this.addChild(trainsMask);
        this.mask = trainsMask;
    }

    public initReel(symbols:IFsSymbolData[]):void {}

    public show(reelData: IFsSymbolData[], isFromIntro: boolean): void {}
    public hide():void {
        this._allSymbols.forEach((symbol:FreespinTrainSymbol, i:number) => {
            this._container.removeChild(symbol);
        });
    }

    public createSymbol(symbolData:IFsSymbolData):FreespinTrainSymbol {
        let symbol:FreespinTrainSymbol = new FreespinTrainSymbol(symbolData);
        this._container.addChild(symbol);
        return symbol;
    }

    public spin(delay:number, hasAnticipation:boolean):gsap.core.Timeline {
        return gsap.timeline();
    }

    public getSymbol(position:number):FreespinTrainSymbol {
        if(position > (this._allSymbols.length - 1)) {
            debugger;
        }
        return this._allSymbols[position];
    }
}